import createDisplayName from "../../../../fabrics/createDisplayName";
import { BUTTON_CIRCLE_DISPLAY_NAME } from "../ButtonCircle";

export const createDisplayNameForButtonCircleElement = createDisplayName(
    BUTTON_CIRCLE_DISPLAY_NAME,
);
